<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

            <!-- Page Header -->
            <div class="page-header mb-3">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <h3 class="page-title">Deals Dashboard</h3>
                    </div>
                    <div class="col-md-8 float-end ms-auto">
                        <div class="d-flex title-head">
                            <div class="view-icons">
                                <a href="javascript:void(0);" class="grid-view btn btn-link"><i
                                        class="las la-redo-alt"></i></a>
                                <a href="javascript:void(0);" class="list-view btn btn-link" @click="toggleFullscreen" id="collapse-header"><i
                                        class="las la-expand-arrows-alt"></i></a>
                            </div>
                            <div class="form-sort">
                                <a href="javascript:void(0);" class="list-view btn btn-link"><i
                                        class="las la-file-export"></i>Export</a>
                            </div>
                            <div class="daterange-picker d-flex">
                                <div class="form-sort">
                                    <i class="las la-calendar"></i>
                                    <input type="text" class="form-control  date-range bookingrange" ref="dateRangeInput">
                                </div>
                                <div class="form-sort">
                                    <i class="las la-cubes"></i>
                                    <vue-select :options="Dashboard" id="dealsdashboard" placeholder="Deals Dashboard" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- /Page Header -->

            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="statistic-header">
                                <h4>Deals By Stage</h4>
                                <div class="dropdown statistic-dropdown">
                                    <div class="card-select">
                                        <ul>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Marketing Pipeline
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Marketing Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Sales Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Email
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Chats
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Operational
                                                    </a>
                                                </div>
                                            </li>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Last 3 months
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 3 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 6 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 12 months
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div id="deals-chart"></div>
                                <apexchart type="bar" height="270" :options="dealsChart.chart" :series="dealsChart.series">
                                </apexchart>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex">
                    <div class="card analytics-card w-100">
                        <div class="card-body">
                            <div class="statistic-header">
                                <h4>Recently Created Contacts<a href="javascript:void(0);" class="text-muted"><i
                                            class="la la-link ms-1"></i></a></h4>
                                <div class="dropdown statistic-dropdown">
                                    <div class="card-select">
                                        <ul>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Last 3 months
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 3 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 6 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 12 months
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table custom-table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Deal Name</th>
                                            <th>Stage</th>
                                            <th>Deal Value</th>
                                            <th>Probability</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><router-link to="/crm/deals-details">Collins</router-link></td>
                                            <td>Conversation</td>
                                            <td>$04,51,000</td>
                                            <td>85%</td>
                                            <td><span class="badge bg-inverse-warning">Open</span></td>
                                        </tr>
                                        <tr>
                                            <td><router-link to="/crm/deals-details">Konopelski</router-link></td>
                                            <td>Pipeline</td>
                                            <td>$03,12,500</td>
                                            <td>85%</td>
                                            <td><span class="badge bg-inverse-danger">Lost</span></td>
                                        </tr>
                                        <tr>
                                            <td><router-link to="/crm/deals-details">Adams</router-link></td>
                                            <td>Won</td>
                                            <td>$04,14,800</td>
                                            <td>80%</td>
                                            <td><span class="badge bg-inverse-success">Won</span></td>
                                        </tr>
                                        <tr>
                                            <td><router-link to="/crm/deals-details">Schumm</router-link></td>
                                            <td>Lost</td>
                                            <td>$9,14,400</td>
                                            <td>47%</td>
                                            <td><span class="badge bg-inverse-danger">Lost</span></td>
                                        </tr>
                                        <tr>
                                            <td><router-link to="/crm/deals-details">Wisozk</router-link></td>
                                            <td>Follow Up</td>
                                            <td>$11,14,400</td>
                                            <td>98%</td>
                                            <td><span class="badge bg-inverse-danger">Lost</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="statistic-header">
                                <h4>Lost Deals Stage</h4>
                                <div class="dropdown statistic-dropdown">
                                    <div class="card-select">
                                        <ul>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Marketing Pipeline
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Marketing Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Sales Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Email
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Chats
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Operational
                                                    </a>
                                                </div>
                                            </li>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Last 3 months
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 3 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 6 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 12 months
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div id="last-chart"></div>
                            <apexchart
                                type="bar"
                                height="150"
                                :options="lastChart.chart"
                                :series="lastChart.series"
                            ></apexchart>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body ">
                            <div class="statistic-header">
                                <h4>Won Deals Stage</h4>
                                <div class="dropdown statistic-dropdown">
                                    <div class="card-select">
                                        <ul>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Marketing Pipeline
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Marketing Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Sales Pipeline
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Email
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Chats
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Operational
                                                    </a>
                                                </div>
                                            </li>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Last 3 months
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 3 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 6 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 12 months
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div id="won-chart"></div>
                            <apexchart
                                type="bar"
                                height="150"
                                :options="wonChart.chart"
                                :series="wonChart.series"
                            ></apexchart>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card mb-0">
                        <div class="card-body">
                            <div class="statistic-header">
                                <h4>Deals by Year</h4>
                                <div class="dropdown statistic-dropdown">
                                    <div class="card-select">
                                        <ul>
                                            <li>
                                                <a class="dropdown-toggle" data-bs-toggle="dropdown"
                                                    href="javascript:void(0);">
                                                    Last 3 months
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">

                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 3 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 6 months
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item">
                                                        Last 12 months
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div id="year-chart"></div>
                            <apexchart
                                type="line"
                                height="350"
                                :options="yearChart.chart"
                                :series="yearChart.series"
                            ></apexchart>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- /Page Content -->

    </div>
    <!-- /Page Wrapper -->
</template>

<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";

import { dealsChart, lastChart, wonChart, yearChart } from "./data";

export default {
    data() {
        return {
            Dashboard: ["Deals Dashboard", "Leads Dashboard"],
            dealsChart: dealsChart,
            lastChart: lastChart,
            wonChart: wonChart,
            yearChart: yearChart,
        }
    },
    methods: {
		toggleFullscreen() {
			const elem = document.documentElement;
			if (
				!document.fullscreenElement &&
				!document.mozFullScreenElement &&
				!document.webkitFullscreenElement &&
				!document.msFullscreenElement
			) {
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.msRequestFullscreen) {
					elem.msRequestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) {
					elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
				}
			} else {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				}
			}
		},
		toggleFilter(event) {
			const formSorts = this.$refs.formSorts;

			if (formSorts.classList.contains("table-filter-show")) {
				formSorts.classList.remove("table-filter-show");
			} else {
				formSorts.classList.add("table-filter-show");
			}

			event.stopPropagation();
		},
		handleDocumentClick(event) {
			const formSorts = this.$refs.formSorts;

			if (formSorts && !event.target.classList.contains("form-sorts")) {
				formSorts.classList.remove("table-filter-show");
			}
		}

	},
	mounted() {
		document.addEventListener("click", this.handleDocumentClick);
	},

	beforeUnmount() {
		document.removeEventListener("click", this.handleDocumentClick);
	},
    setup() {
    const dateRangeInput = ref(null);
    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        function booking_range(start, end) {
          // Move the function declaration to the root level of the function body
          function formatDate(date) {
            return date.format("M/D/YYYY");
          }

          return formatDate(start) + " - " + formatDate(end);
        }

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment().endOf("month")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
    });
    return {
      dateRangeInput,
    };
  },
}
</script>